import React from "react";
import { Check } from "lucide-react";

const ReviewSubmit = ({ questionnaireData, questionnaireSubmitted }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">Review & Submit</h3>
      <p className="text-gray-600">
        Please review your information before submitting.
      </p>

      {questionnaireSubmitted ? (
        <div className="bg-green-50 p-4 rounded-lg">
          <p className="text-sm text-green-800 flex items-center">
            <Check className="mr-2" size={16} />
            <span>
              Questionnaire successfully submitted! You can edit your responses
              or proceed to the next step.
            </span>
          </p>
        </div>
      ) : (
        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-blue-800 flex items-center">
            <Check className="mr-2" size={16} />
            <span>Your questionnaire is ready to submit.</span>
          </p>
        </div>
      )}

      {/* Organization Profile Summary */}
      <div className="border border-gray-200 rounded-lg p-4">
        <h4 className="text-lg font-medium text-gray-900 mb-2">
          Organization Profile
        </h4>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <span className="text-sm text-gray-500">Organization Name:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.name || "—"}
            </p>
          </div>
          <div>
            <span className="text-sm text-gray-500">Contact:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.contactName || "—"}
            </p>
          </div>
          <div>
            <span className="text-sm text-gray-500">Contact Email:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.contactEmail || "—"}
            </p>
          </div>
          <div>
            <span className="text-sm text-gray-500">Contact Phone:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.contactPhone || "—"}
            </p>
          </div>
          <div>
            <span className="text-sm text-gray-500">Organization Size:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.size || "—"}
            </p>
          </div>
          <div>
            <span className="text-sm text-gray-500">Sector:</span>
            <p className="font-medium">
              {questionnaireData.orgProfile.sector || "—"}
            </p>
          </div>
        </div>
      </div>

      {/* SKU Selection Summary */}
      <div className="border border-gray-200 rounded-lg p-4">
        <h4 className="text-lg font-medium text-gray-900 mb-2">
          Selected SKUs
        </h4>
        {questionnaireData.skuSelection.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {questionnaireData.skuSelection.map((sku) => (
              <span
                key={sku}
                className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
              >
                {sku}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No SKUs selected</p>
        )}
      </div>

      {/* Configuration Summary */}
      <div className="border border-gray-200 rounded-lg p-4">
        <h4 className="text-lg font-medium text-gray-900 mb-2">
          Configuration Setup
        </h4>
        <p className="text-sm text-gray-600">
          {Object.keys(questionnaireData.configSetup).reduce((count, key) => {
            return count + (questionnaireData.configSetup[key]?.length || 0);
          }, 0)}{" "}
          configuration items defined across{" "}
          {Object.keys(questionnaireData.configSetup).length} categories.
        </p>
      </div>

      {/* Foundational Setup Summary */}
      <div className="border border-gray-200 rounded-lg p-4">
        <h4 className="text-lg font-medium text-gray-900 mb-2">
          Foundational Setup
        </h4>
        <p className="text-sm text-gray-600">
          {Object.keys(questionnaireData.foundationalSetup).reduce(
            (count, key) => {
              return (
                count + (questionnaireData.foundationalSetup[key]?.length || 0)
              );
            },
            0
          )}{" "}
          foundational items defined across{" "}
          {Object.keys(questionnaireData.foundationalSetup).length} categories.
        </p>
      </div>
    </div>
  );
};

export default ReviewSubmit;
